import React from 'react';
import { Card, Skeleton, Row, Col, Spin, Flex } from 'antd';

interface ReviewsSkeletonProps {
    count?: number;
}

const ReviewsSkeleton: React.FC<ReviewsSkeletonProps> = ({ count = 5 }) => {
    const getColSpan = (index: number) => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth >= 1024) return 8;  // Desktop: 3 cards (24/3 = 8)
            if (window.innerWidth >= 768) return 12; // Tablet: 2 cards (24/2 = 12)
            return 24; // Mobile: 1 card (24/1 = 24)
        }
        return 8;
    };

    return (
        <div className="review-skeleton">
            <Flex align='center' justify='center' style={{ height: '100%' }}>
                <Spin tip="กำลังโหลดข้อมูล..." />
            </Flex>
        </div>
    );
};

export default ReviewsSkeleton; 